import React, { useContext } from "react"
import { useSettings, useIsEditing, TemplateContext } from "../editor"
import raw from "raw.macro"
import { styles } from "../settings/space"
import { useOverride } from "../editor"
import { formatAndScopeCss } from "../utils/format-and-scope-css"

function Responsive({ children, backgroundColor: backgroundColorSettingName }) {
  const settings = useSettings()
  const colorSetting = settings.find(s => s.name === backgroundColorSettingName)
  const spaceSetting = settings.find(s => s.type === "space")
  const backgroundColor = colorSetting?.value || "#ffffff"
  const space = spaceSetting?.value || "normal"
  const classicTemplate = useOverride("inClassicTemplate")

  const padding = space === "full" ? 0 : "20px"
  const horizontalSpacing = classicTemplate ? padding : 0
  const topSpacing = classicTemplate ? "30px" : 0
  const maxWidth = styles[space || "normal"].content.maxWidth

  return (
    <div style={{ backgroundColor }}>
      <table
        role="presentation"
        cellPadding="0"
        cellSpacing="0"
        className="email"
        style={{ width: "100%" }}
        bgcolor={backgroundColor}
      >
        <tbody>
          <tr>
            <td>
              <div
                className={`email-container ${space}`}
                style={{
                  paddingTop: topSpacing,
                  paddingLeft: horizontalSpacing,
                  paddingBottom: "30px",
                  paddingRight: horizontalSpacing,
                  margin: "0 auto",
                  maxWidth
                }}
              >
                {children}
              </div>
            </td>
            <td />
          </tr>
        </tbody>
      </table>
    </div>
  )
}

function Plain({ children }) {
  return <div className="email">{children}</div>
}

function Email({ children, backgroundColor, layout = "responsive" }) {
  const settings = useSettings()
  const isEditing = useIsEditing()
  const template = useContext(TemplateContext)
  const inClassicTemplate = useOverride("inClassicTemplate")

  // Scope all the CSS when editing.
  const scope = isEditing ? ".template-editor" : ""
  const sharedCSS = formatAndScopeCss(scope, raw("../styles/shared.css"))
  const editingCSS = formatAndScopeCss(scope, raw("../styles/editing.css"))
  const settingsCSS = formatAndScopeCss(
    scope,
    settings.map(setting => setting.css).join("\n")
  )

  const templateCSS = formatAndScopeCss(
    scope,
    template.styles
      .filter(style => !style.noInline)
      .map(style => {
        if (!isEditing && style.editorOnly) return ""
        return style.css
      })
      .join("")
  )

  const templateNoInlineCSS = formatAndScopeCss(
    scope,
    template.styles
      .filter(style => style.noInline)
      .map(style => {
        if (!isEditing && style.editorOnly) return ""
        return style.css
      })
      .join("")
  )

  const Layout = layout === "responsive" ? Responsive : Plain

  return (
    <Layout backgroundColor={backgroundColor}>
      {isEditing && <style dangerouslySetInnerHTML={{ __html: editingCSS }} />}
      {inClassicTemplate && (
        <style dangerouslySetInnerHTML={{ __html: sharedCSS }} />
      )}
      <style dangerouslySetInnerHTML={{ __html: templateCSS }} />
      {templateNoInlineCSS && (
        <style
          data-no-inline
          dangerouslySetInnerHTML={{ __html: templateNoInlineCSS }}
        />
      )}
      <style dangerouslySetInnerHTML={{ __html: settingsCSS }} />
      {children}
    </Layout>
  )
}

export default Email
